(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TravelDealOptin',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		// just for this, widen the whitelist of allowed markup in popups
		// so we can plop the signup form in it.
		// all data being populated comes directly from our db and is not
		// user changeable
		$.fn.tooltip.Constructor.DEFAULTS.whiteList.form     = /^.+/;
		$.fn.tooltip.Constructor.DEFAULTS.whiteList.input    = /^.+/;
		$.fn.tooltip.Constructor.DEFAULTS.whiteList.button   = /^.+/;
		$.fn.tooltip.Constructor.DEFAULTS.whiteList.label    = /^.+/;
		$.fn.tooltip.Constructor.DEFAULTS.whiteList.select   = /^.+/;
		$.fn.tooltip.Constructor.DEFAULTS.whiteList.option   = /^.+/;
		$.fn.tooltip.Constructor.DEFAULTS.whiteList.optgroup = /^.+/;


		// for the index page
		$form.find('.show-form').popover({
			html     : true,
			container: 'form[name="TravelDealOptin"]',
			placement: 'auto left',
			content  : $('.signup-form').html(),
		}).on("show.bs.popover", function wideOptIn() {
			var email = $.trim($form.find('#traveldealoptin-email').val());
			if (!email || !Adzuki.String.isEmail(email)) {
				Adzuki.StatusMessage('error', 'Please enter a valid email address.');
				return false;
			}

			$(this).data("bs.popover").tip().css("max-width", "600px");
		}).on('shown.bs.popover', function optInFormShown() {
			// check the opt-in for text messages when entering a phone number
			$('.popover #traveldealoptin-mobile_phone').first().on('blur', function onPhoneFieldBlur(e)
			{
				var $self   = $(this);
				var checked = false;

				if ($self.val() !== '') {
					checked = true;
				}

				$('.popover #traveldealoptin-mobile_receive_texts').first().prop('checked', checked);
				$('.popover #traveldealoptin-mobile_receive_travel_texts').first().prop('checked', checked);
				$('.popover #traveldealoptin-mobile_receive_fit_builder_texts').first().prop('checked', checked);
			});
		});

		// in order to get the travel deal popover to auto-hide when clicking
		// outside of it, you need to set its trigger to focus (bootstrap built-in).
		// trouble is, when using the form, the button loses focus, which
		// hides the popover with the form. that's no good.
		$('body').click(function dismissOptinPopover()
		{
			var $target = $(event.target),
			    $popover;

			// dont auto-close popovers if
			// 	you click anywhere inside of the popover
			// 	you click in an alerts (like a form error)
			// 	you click on the button to show the optin form
			// 	you click on a datepicker
			if ($target.length && (
				$target.parents('.popover').length ||
				$target.parents('.jconfirm-box').length ||
				$target.attr('type') === 'date' ||
				event.target.classList.contains('show-form')
			)) {
				return;
			}

			$popover = $('.popover');

			if ($popover.length) {
				// hide the popover and reset its internal state
				$popover.popover('hide').data("bs.popover").inState = {
					click: false,
					hover: false,
					focus: false,
				};
			}
		});

		// check the opt-in for text messages when entering a phone number
		// this would only apply in the stand-alone form /TravelDeals/optIn
		$('#traveldealoptin-mobile_phone').first().on('blur', function onPhoneFieldBlur(e)
		{
			var $self   = $(this);
			var checked = false;

			if ($self.val() !== '') {
				checked = true;
			}

			$('#traveldealoptin-mobile_receive_texts').first().prop('checked', checked);
			$('#traveldealoptin-mobile_receive_travel_texts').first().prop('checked', checked);
			$('#traveldealoptin-mobile_receive_fit_builder_texts').first().prop('checked', checked);
		});
	};

}(jQuery, window.Adzuki || {}));
